﻿$.fn.dxCtrlBrowserEmail = function custom_dxCtrlBrowserEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbrowseremail dx-ctrl");
        this.createInstance(new cdxCtrlBrowserEmail(this, option));
    }
    return this;
}

window.cdxCtrlBrowserEmail = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivContainer = null
    function mConstruit() {
        container.empty()
        container.css({
            "width": "100%",
            "height": "100%",
            "text-align": "center",
            color: "black",
            "background-color": "white",
            "padding": "0",
            "min-height": "100%",
            "overflow-y": "auto"
        })
        $DivContainer = $("<div style='width:100%;display:inline-block;height:100%;'/>").appendTo(container)

        if (typeof option.urlFile != 'undefined') {
            option.bddCtrl.mAjaxCall({
                command: "getdataemailfichiervisu",
                tick: option.tick,
                path_nom_fichier: option.urlFile
            }, function (data) {
                mRempli(data)
            }, null, function (data) {
                //bug
                mRempli({})
            })
        } else if (typeof option.idCom != 'undefined') {
            option.bddCtrl.mAjaxCall({
                command: "getdataemailbddvisu",
                tick: option.tick,
                id_com_dest: option.idComDest,
                id_com: option.idCom
            }, function (data) {
                mRempli(data)
            }, null, function (data) {
                //bug
                mRempli({})
            })
        }
    }

    function mRempli(data) {
        if (typeof data.urlhtml == 'undefined') {
            //on a pas de résultat
            $DivContainer.remove()
            container.css("overflow", "")
            $iFrame = $("<iframe style='width:100%;border:none;background-color:white;height:100%;' src ='" + parametre.url_site_vitrine + "'/></iframe>").appendTo(container)
        } else {
            if (data.objet != null && data.objet.length != 0) document.title = data.objet
            var $DivObjet = $("<div style='text-align:center;padding:5px 15px;position:sticky;top:0;background-color:white;z-index:1;width:100%'>" + ((data.objet == null || data.objet.length == 0) ? "..." : data.objet) + "</div>").appendTo($DivContainer)
            var dxCtrlFichierJoint = null
            if (typeof data.lstfile != 'undefined' && data.lstfile.length > 0) {
                dxCtrlFichierJoint = $("<div style='position:sticky;top:" + $DivObjet.innerHeight() + "px;background-color:white;z-index:1;'/>").appendTo($DivContainer).dxCtrlFichier2Document({
                    bddCtrl: option.bddCtrl,
                    dataSource: data.lstfile,
                    readOnly: true,
                    downloadFile: true
                }).dxCtrlFichier2Document("instance")
            }
            var dxIframe = $("<div style='position:relative;z-index:0;'/>").appendTo($DivContainer).dxCtrlIframeResize({
                src: data.urlhtml
            }).dxCtrlIframeResize("instance")
            resizeObserver.mAdd(container, function () {
                //dxIframe.css("top", ($DivObjet.innerHeight() + ((dxCtrlFichierJoint) ? dxCtrlFichierJoint.element().innerHeight() : 0)) + "px")
                if (dxCtrlFichierJoint) dxCtrlFichierJoint.element().css("top", $DivObjet.innerHeight() + "px")
            })
            resizeObserver.mAdd($DivObjet, function () {
                //dxIframe.css("top", ($DivObjet.innerHeight() + ((dxCtrlFichierJoint) ? dxCtrlFichierJoint.element().innerHeight() : 0)) + "px")
                if (dxCtrlFichierJoint) dxCtrlFichierJoint.element().css("top", $DivObjet.innerHeight() + "px")
            })
        }

        if (typeof option.unSubScribe != 'undefined' && (option.unSubScribe == "1" || option.unSubScribe == "3") && option.adresseEmail.length > 0) {
            //popup de désinscription ou pixel suivi
            function mHideLink() {
                try {
                    if ($($(dxIframe.element()).find("iframe")).contents().find("body").find(".ADesinscription").length == 0) {
                        window.setTimeout(function () {
                            mHideLink()
                        }, 100)
                    } else {
                        $($(dxIframe.element()).find("iframe")).contents().find("body").find(".ADesinscription").hide()
                        $($(dxIframe.element()).find("iframe")).contents().find("body").find(".AViewBrowser").hide()
                        $($(dxIframe.element()).find("iframe")).contents().find("body").find(".ApopsoftVoirDansNavigateur").hide()
                        $($(dxIframe.element()).find("iframe")).contents().find("body").find(".RGPDpopsoftADesinscription").hide()
                    }
                } catch (e) {
                    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                }
            }
            mHideLink()

            var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                showTitle: false,
                shading: true,
                fullScreen: false,
                height: "auto",
                maxWidth: 500,
                width: "100%",
                hideOnOutsideClick: true,
                position: {
                    my: "top",
                    at: "top",
                    of: "body",
                    offset: "0 50"
                },
                contentTemplate: function (contentElement) {
                    contentElement.css("text-align", "center")
                    contentElement.css("padding", "25px")
                    if (typeof data.urlhtml == 'undefined') {
                        $("<div style='padding:10px;'>Ce message n'existe plus</div>").appendTo(contentElement)
                    }
                    switch (parseInt(option.unSubScribe)) {
                        case 1:
                            //désinscription
                            $("<div style='opacity:0.5;'>Voulez vous vraiment désinscrire l'adresse email suivante ?</div>").appendTo(contentElement)
                            break;
                        case 3:
                            //pixelsuivi
                            $("<div style='opacity:0.5;'>Voulez vous vraiment désactiver le pixel de suivi pour l'adresse email suivante ?</div>").appendTo(contentElement)
                            break;
                    }
                    $("<div style='padding-top:20px;'><u>" + option.adresseEmail + "</u></div>").appendTo(contentElement)
                    $("<hr style='opacity:0.3;margin-top:25px;'/>").appendTo(contentElement)

                    var $Table = $("<table style='width:100%;display:inline-block;'/>").appendTo(contentElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:1px;cursor:pointer;'/>").appendTo($Tr)
                    $Td.on("click", function () {
                        option.bddCtrl.mAjaxCall({ command: "clickpubdesinscription", adresse_email: option.adresseEmail })
                        window.open(parametre.urldispatch + "/pageSite.aspx?nb=" + option.bddCtrl.nom_base + "&iddest=" + option.idComDest + "&typ=1", "_blank")
                    })
                    var urlPub = parametre.urldispatch + "/img/logo/" + parametre.code_appli + "_pubemail42.png"
                    $("<img src='" + urlPub + "' style='height:42px;' alt='Sent with " + parametre.nom + "'/>").appendTo($Td)

                    var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
                    //var appli = parametre.lst_appli_all.filter(function (o) { return o.code_appli == parametre.code_appli })[0]
                    //var $Div = $("<div style='cursor:pointer;'><span>" + appli.nom + "</span><br/>" + appli.phrase_accroche + "</span></div>").appendTo($Td)
                    //$Div.on("click", function () {
                    //    option.bddCtrl.mAjaxCall({ command: "clickpubdesinscription", adresse_email: option.adresseEmail })
                    //    window.open(parametre.urldispatch + "/pageSite.aspx?nb=" + option.bddCtrl.nom_base + "&iddest=" + option.idComDest + "&typ=1", "_blank")
                    //})

                    var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Oui, me désinscrire",
                        onClick: function (e) {
                            option.bddCtrl.mAjaxCall({
                                command: "sedesinscrire",
                                adresse_email: option.adresseEmail,
                                id_com_email_envoi: option.idCom,
                                id_com_destinataire: option.idComDest,
                                type_desinscription: option.unSubScribe
                            })
                            popup.hide()
                            mConfirmeDesinscription()
                        }
                    })
                    var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Annuler",
                        onClick: function (e) {
                            popup.hide()
                        }
                    })
                },
                onShown: function (e) {
                    jaugeDemarrage.mHide()
                }
            }).dxCtrlPopupBase("instance")
            popup.show()
        } else {
            if (typeof data.urlhtml == 'undefined') {
                var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                    showTitle: false,
                    shading: true,
                    fullScreen: false,
                    height: "auto",
                    maxWidth: 500,
                    width: "100%",
                    hideOnOutsideClick: true,
                    position: {
                        my: "top",
                        at: "top",
                        of: "body",
                        offset: "0 50"
                    },
                    contentTemplate: function (contentElement) {
                        contentElement.css("text-align", "center")
                        $("<div>Ce message n'existe plus</div>").appendTo(contentElement)
                        $("<hr style='opacity:0.3'/>").appendTo(contentElement)

                        var $Table = $("<table style='width:100%;display:inline-block;'/>").appendTo(contentElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
                        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlButton({
                            text: "Ok",
                            onClick: function (e) {
                                popup.hide()
                            }
                        })
                        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
                    },
                    onShown: function (e) {
                        jaugeDemarrage.mHide()
                    }
                }).dxCtrlPopupBase("instance")
                popup.show()
            } else {
                jaugeDemarrage.mHide()
            }
        }
    }

    function mConfirmeDesinscription() {
        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            showTitle: false,
            shading: true,
            fullScreen: false,
            height: "auto",
            maxWidth: 500,
            hideOnOutsideClick: true,
            position: {
                my: "top",
                at: "top",
                of: "body",
                offset: "0 50"
            },
            contentTemplate: function (contentElement) {
                contentElement.css("text-align", "center")
                $("<div style='color:green;padding-bottom:20px;'>Votre désinscription a été enregistrée</div>").appendTo(contentElement)
                $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlButton({
                    text: "Fermer",
                    onClick: function (e) {
                        popup.hide()
                    }
                })
            },
            onShown: function (e) {
                jaugeDemarrage.mHide()
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    this.element = function () { return container }

    mConstruit();
}